
import { mapActions, mapMutations, mapState} from 'vuex'
import Previewer from 'vux/src/components/previewer/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import $ from 'jquery'
import imgSrc from '../assets/javascripts/imgSrc'
import _ from 'lodash'
import utils from '../assets/javascripts/utils'
import url from 'url'

let bullets = [
{
text: '正视图',
className: 'pagination-bullet font-12'
},
{
text: '侧视图',
className: 'pagination-bullet font-12'
}
];

export default {
components: {
swiper,
swiperSlide,
Previewer,
Loading
},
methods: {
go(path) {
this.$router.push(path)
},
createCanvas(option) {
let _this = this;
let NAMES = this.NAMES;
let level = this.level;
let canvasDom = null;
let getImg = new Promise(function (resolved, rejected) {
let img = new Image();
img.onload = function () {
resolved(img)
};
img.src = option.src;
})

canvasDom = getImg.then(function (img) {
let width = img.width;
let height = img.height;
let canvas = document.createElement('canvas');
canvas.width = width;
canvas.height = height;
canvas.style.width = '100%';
_this[option.key].scale = $(option.destination).width() / width;
let cxt = canvas.getContext('2d');
cxt.drawImage(img, 0, 0, width, height);
if(option.key == 'face') {
for(let i = 0; i < option.data.length; i++) {
if(option.data[i].valid) {

if(option.data[i].position == NAMES.pelvis) {
cxt.save();
cxt.lineWidth = 3;
cxt.strokeStyle = '#009901';
cxt.beginPath();
cxt.arc((option.data[i].points[0].x + option.data[i].points[1].x) / 2, (option.data[i].points[0].y + option.data[i].points[1].y) / 2, Math.abs((option.data[i].points[1].x - option.data[i].points[0].x)) / 2, 0, 2*Math.PI);
cxt.closePath();
cxt.stroke();
cxt.restore();
}

if(option.data[i].level == level.normal) {


if(option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {
cxt.save();
cxt.setLineDash([4,6]);
cxt.lineWidth = 5;
cxt.strokeStyle = '#009901';
cxt.beginPath();
cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
cxt.closePath();
cxt.stroke();
cxt.restore();
} else {

cxt.save();
cxt.setLineDash([5, 6]);
cxt.lineWidth = 3;
cxt.strokeStyle = '#009901';
cxt.beginPath();
if(option.data[i].position == NAMES['lower extremity']) {
cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y );
cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y );
} else {
cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
}
cxt.closePath();
cxt.stroke();
cxt.restore();
}
} else {

if(option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {

cxt.save();
cxt.setLineDash([4,6]);
cxt.lineWidth = 3;
cxt.strokeStyle = '#009901';
cxt.beginPath();
cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
cxt.closePath();
cxt.stroke();
cxt.restore();


cxt.save();
cxt.lineWidth = 3;
cxt.strokeStyle = '#ff1605';
cxt.beginPath();
cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
cxt.lineTo(option.data[i].points[1].x, option.data[i].points[1].y);
cxt.closePath();
cxt.stroke();
cxt.restore();
} else {

cxt.save();
cxt.setLineDash([5, 6]);
cxt.lineWidth = 3;
cxt.strokeStyle = '#009901';
cxt.beginPath();
if(option.data[i].position == NAMES['lower extremity']) {
cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y );
cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y );
} else {
cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
}
cxt.closePath();
cxt.stroke();
cxt.restore();


cxt.save();
cxt.lineWidth = 3;
cxt.strokeStyle = '#ff1605';
cxt.beginPath();
for(let j = 0; j < option.data[i].points.length; j++) {
if(j == 0) {
cxt.moveTo(option.data[i].points[j].x, option.data[i].points[j].y);
} else {
cxt.lineTo(option.data[i].points[j].x, option.data[i].points[j].y);
}
}
cxt.stroke();
cxt.restore();
}
}
}
}
} else {
for(let i = 0; i < option.data.length; i++) {
if(option.data[i].valid) {
if(option.data[i].position == NAMES.shoulder) {
cxt.save();
cxt.lineWidth = 3;
cxt.setLineDash([4, 6]);
cxt.strokeStyle = '#009901';
cxt.beginPath();
cxt.moveTo(option.data[i].points[1].x, 0.1 * height);
cxt.lineTo(option.data[i].points[1].x, 0.9 * height);
cxt.closePath();
cxt.stroke();
cxt.restore()
}

if(option.data[i].level !== level.normal) {
cxt.save();
cxt.lineWidth = 3;
cxt.strokeStyle = '#ff1605';
cxt.beginPath();
for(let j = 0; j < option.data[i].points.length; j++) {
if(j == 0) {
cxt.moveTo(option.data[i].points[j].x, option.data[i].points[j].y)
} else {
cxt.lineTo(option.data[i].points[j].x, option.data[i].points[j].y)
}
}
cxt.stroke();
cxt.restore()
}
}
}
}
canvas.id = option.destination.slice(1) + 'Canvas';
$(option.destination).append(canvas)
})
},


















...mapState({
initReportData(state) {
let reportData = state.vux.reportData;
let _this = this;
if(_.isNull(reportData)) {
let uuid = '';
let type = '';

let urlquery = url.parse(window.location.href).query;
let query = urlquery.split('&');
for (let every = 0; every < query.length; every++) {
if (query[every].indexOf('uuid=') != -1) {
uuid = query[every].replace('uuid=', '');
}
if (query[every].indexOf('type=') != -1) {
type = query[every].replace('type=', '');
}
}

this.get({
url: `v1/posture/reports/${uuid}`,
params: {
type: type
},
success(result) {
_this.updateReportData({
reportData: result
});
_this.getReportData();
console.log('result=>', result)
},
error(data) {
_this.loading = false;
_this.valid = false
}
})
} else {
_this.getReportData();
}
},
getReportData(state) {
this.loading = false;
let reportData = state.vux.reportData;
this.reportData = reportData;
if(_.isNull(reportData.customer)) {
this.customer = {
avatar: null,
name: '--'
}
} else {
this.customer = reportData.customer;
}

if(_.isNull(reportData.conclusion.risks)) {
this.valid = false
} else {
this.initPostureImg();
}
},
initPostureImg(state) {
let reportData = state.vux.reportData;
console.log('reportData =>', reportData);
let face = {
key: 'face',
src: reportData.face,
destination: '#face',
data: []
};
let side = {
key: 'side',
src: reportData.side,
destination: '#side',
data: []
};

let NAMES = this.NAMES;

for(let i = 0; i < reportData.conclusion.risks.length; i++) {
if((reportData.conclusion.risks[i].position == NAMES.head && reportData.conclusion.risks[i].code == 2) || (reportData.conclusion.risks[i].position == NAMES.shoulder && reportData.conclusion.risks[i].code == 2) || (reportData.conclusion.risks[i].position == NAMES['lower extremity'] && reportData.conclusion.risks[i].code == 3)) {
if(_.isNull(reportData.conclusion.risks[i].points)) {
side.data.push(reportData.conclusion.risks[i]);
continue;
}
reportData.conclusion.risks[i].coord = {};
reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
reportData.conclusion.risks[i].coord.left = 44;
side.data.push(reportData.conclusion.risks[i])
} else  {
if(_.isNull(reportData.conclusion.risks[i].points)) {
face.data.push(reportData.conclusion.risks[i]);
continue;
}
reportData.conclusion.risks[i].coord = {};

switch (reportData.conclusion.risks[i].position) {
case NAMES['lower extremity']:
reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[2].y) / 2;
break;
case NAMES.trunk:
reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[1].y) / 2;
break;
default:
reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
break;
}


switch (reportData.conclusion.risks[i].position) {
case NAMES['lower extremity']:
reportData.conclusion.risks[i].coord.left = 44;
break;
case NAMES['trunk']:
reportData.conclusion.risks[i].coord.left = 44;
break;
default:
reportData.conclusion.risks[i].coord.right = 44;
break;
}

face.data.push(reportData.conclusion.risks[i])
}
}
this.face.data = face.data;
this.side.data = side.data;
this.createCanvas(face);
this.createCanvas(side);

}
}),
...mapActions(['get']),
...mapMutations(['updateReportData'])
},
data() {
return {
bullets: [
{
text: 'front',
className: 'pagination-bullet font-12'
},
{
text: 'side',
className: 'pagination-bullet font-12'
}
],
swiperOption: {
pagination: {
el: '.posture-swiper-pagination',
clickable: true,
renderBullet(index, className) {
return `<span class="${className} ${bullets[index].className}">${bullets[index].text}</span>`
}
},
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev'
}
},
face: {
data: [],
scale: 0
},
side: {
data: [],
scale: 0
},
reportData: {},
valid: true,
showImg: false,
NAMES: {
head: 'head',
shoulder: 'shoulder',
trunk: 'trunk',
pelvis: 'pelvis',
"lower extremity": 'lower extremity',
},
level: {
normal: 'normal',
mild: 'mild',
severe: 'severe'
},
loading: true,
customer: {}
}
},
computed: {
avatar: function() {
return _.isNull(this.customer.avatar) ? imgSrc.DEFAULT_AVATAR : utils.base64ToSrc(this.customer.avatar)
}
},
created() {
this.initReportData();
},
mounted() {
}
}



// WEBPACK FOOTER //
// ./src/components/Home.vue